import { apiRequest } from '../api/client';

/** Always 202, whether or not the address is registered. */
export function requestPasswordReset(email: string): Promise<void> {
  return apiRequest('/auth/password-reset', {
    method: 'POST',
    body: JSON.stringify({ email }),
  });
}

export function confirmPasswordReset(token: string, newPassword: string): Promise<void> {
  return apiRequest('/auth/password-reset/confirm', {
    method: 'POST',
    body: JSON.stringify({ token, newPassword }),
  });
}
